




















































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { KeyAction } from '@/model/KeyAction'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import { keyActionService } from '@/services/key-action-service'
import ProfitCenterForm from '@/components/settings/profit-center/ProfitCenterForm.vue'
import ProfitCenterDepartment from '@/components/settings/profit-center/ProfitCenterDepartment.vue'
import ProfitCenterBank from '@/components/settings/profit-center/ProfitCenterBank.vue'
import ProfitCenterAdditionalFields from '@/components/additional-fields/ProfitCenterAdditionalFields.vue'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  loading: boolean
  storageLoading: boolean
  priceLoading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  activeTab: number
  isCreate: boolean
  isUpdate: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProfitCenterPage',

  components: {
    ProfitCenterForm,
    ProfitCenterDepartment,
    ProfitCenterBank,
    ProfitCenterAdditionalFields
  },

  props: {
    profitCenterId: Number
  },

  data (): ComponentData {
    return {
      loading: false,
      storageLoading: false,
      priceLoading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      activeTab: 0,
      isCreate: false,
      isUpdate: false,

      keyActions: []
    }
  },

  watch: {
    activeTab (newVal: number): void {
      this.isCreate = false
      this.isUpdate = false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    disabledActionButtons (): boolean {
      return this.activeTab === 3 || this.isCreate || this.isUpdate
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if (action instanceof Create) {
        return true
      } else if (action instanceof Edit) {
        return true
      } else if (action instanceof Delete) {
        return true
      } else {
        return false
      }
    },

    onCreateClick ():void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.isCreate = true
      this.isUpdate = false
    },

    onUpdateClick ():void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.isUpdate = true
      this.isCreate = false
    },

    onDeleteClick ():void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.isCreate = false
      this.isUpdate = false
    },

    cancel (): void {
      this.isUpdate = false
      this.isCreate = false
    },

  },

  created (): void {

  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }

})
